import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const MaterialPlanningModule = new Module({
  id: 'INVENTORY-CACHING:MATERIAL-PLANNING',
  name: 'Material Planning',
  label: 'Material Planning',
  path: 'material-planning',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/MaterialPlanning'))
  )
});

export default new ModuleBundle('MaterialPlanning', [MaterialPlanningModule]);
